import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import * as actions from '../../../redux/actions/caseLookupSearchAction';
import { getSidebarData } from '../../../redux/actions/sidebarActions';
import { searchAdvancedFilings } from '../../../redux/actions/advancedSearchAction';
import * as errorActions from '../../../redux/actions/errorAction';
import Loading from '../../../components/common/Loading';
import RefineSearch from './RefineSearch';
import AdvancedSearchRefineSearch from '../../../components/refineSearch/RefineSearch';
import { search as caseLookupSearch } from '../../../components/search/sections/util/caseLookup';
import { firstLetterCapitalize } from '../../../util/text';
import { initialFilters } from '../../../redux/reducers/caseLookupSearchReducer';
import courtsData from '../../../data/courts';
import searchImg from '../../../images/search-sm.png';
import './FacetsBlock.less';
import AdvancedSearchAlert from '../../advancedSearch/Alerts/AdvancedSearchAlert';
import TabOneSection from './TabOneSection';
import TabTwoSection from './TabTwoSection';


const courtsMap = _.groupBy(courtsData, 'code');

const facetsData = {
  case_type: 'Type',
  chapter: 'Chapter',
  year: 'Year field',
  court_name: 'Court',
};

class FacetsBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 1,
    };
  }

  componentDidMount = () => {
    this.props.getSidebarData({ type: this.props.type });
  }

  changeTab = (tab) => {
    this.setState({ selectedTab: tab });
  }

  facetRowClick(facetRow) {
    const nameOfProperty = Object.keys(facetRow)[0];
    const valueOfProperty = facetRow[nameOfProperty];

    if (nameOfProperty === 'case_type') {
      if (valueOfProperty) {
        facetRow[nameOfProperty] = firstLetterCapitalize(valueOfProperty);
      } else {
        facetRow[nameOfProperty] = 'All';
      }
    }

    let searchFilter = facetRow;

    if (facetRow.year) {
      // this is not very terse but it's late for me :|
      facetRow.filed_from = moment(`${facetRow.year}/01/01`);
      facetRow.filed_to = moment(`${facetRow.year}/12/31`);

      searchFilter = {
        filed_from: `${facetRow.year}/01/01`,
        filed_to: `${facetRow.year}/12/31`,
        year: facetRow.year,
      };

      const datepickers = document.getElementsByClassName('react-datepicker__close-icon') || [];
      // can't use forEach on nodeitems in all browsers
      // eslint-disable-next-line
      for (let i = 0; i < datepickers.length; i++) {
        datepickers[i].click();
      }
    }

    if (facetRow.court_name) {
      const { court_name } = facetRow;
      facetRow = { region_name: court_name };
      searchFilter = { region_name: court_name };
    }

    this.props.actions.updateFilter(facetRow);

    caseLookupSearch.bind(this)(searchFilter, false);
  }

  clearAllFilter = () => {
    setTimeout(() => {
      if (this.props.filters.get('year')) {
        // this is a kind of a hack  bc of react-datepicker
        const datepickers = document.getElementsByClassName('react-datepicker__close-icon') || [];
        // eslint-disable-next-line
        for (let i = 0; i < datepickers.length; i++) {
          datepickers[i].click();
        }
      }
      this.props.actions.clearAllFilter();
      caseLookupSearch.bind(this)({}, false);
    });
  };

  hasDataForRefinedSearch = () => {
    // checks if all of the facets data is empty
    const facets = this.props.facets.toJS();
    let containsData = false;
    Object.values(facets).forEach((v) => {
      if (!_.isEmpty(v)) {
        containsData = true;
      }
    });
    return containsData;
  }

  render() {
    const {
      sidebarData,
      type,
      advancedSearchFacets,
      advancedSearchFilter,
      onSearchAdvancedFilings,
      advancedSearchShowResults,
    } = this.props;
    const hasDataForRefinedSearch = this.hasDataForRefinedSearch();

    const tabOneCls = (this.state.selectedTab === 1)
      ? 'ui-tabs-selected'
      : 'ui-state-default';

    const tabTwoCls = (this.state.selectedTab === 2)
      ? 'ui-tabs-selected'
      : 'ui-state-default';

    const refineSearch = (hasDataForRefinedSearch)
      ? <RefineSearch facetsData={facetsData}
                      courtsMap={courtsMap}
                      facets={this.props.facets}
                      facetRowClick={this.facetRowClick.bind(this)} />
      : null;

    const tabOneContent = (type === 'advanced-search' && !hasDataForRefinedSearch)
      ? (
        <React.Fragment>
          <AdvancedSearchAlert />
          {
            advancedSearchFacets && <AdvancedSearchRefineSearch
              facets={advancedSearchFacets}
              advancedSearchFilter={advancedSearchFilter}
              onSearchAdvancedFilings={onSearchAdvancedFilings}
            />
          }
          {!advancedSearchShowResults && <TabOneSection tab={sidebarData.tab_one} sidebarStatus={sidebarData.status} />}
        </React.Fragment>
      )
      : (
        <React.Fragment>
          <TabOneSection tab={sidebarData.tab_one} sidebarStatus={sidebarData.status} />
          { refineSearch }
        </React.Fragment>
      );

    const tabs = (
      <div className="tabs">
        <div className={`tab ${tabOneCls}`}>
          { tabOneContent }
        </div>
        <div className={`tab ${tabTwoCls}`}>
          <TabTwoSection tab={sidebarData.tab_two} sidebarStatus={sidebarData.status} />
        </div>
      </div>
    );

    const loadingOrFacets = (this.props.sidebarData.status === 'loading')
      ? <Loading showOverride type="spinner" />
      : tabs;

    return (
      <div id="sidebar-first" className="facets-block">
        <ul className="ui-tabs-nav ui-helper-reset ui-helper-clearfix">
          <li className={`ui-state-default ${tabOneCls}`} onClick={this.changeTab.bind(null, 1)}>
            <a href="javascript:void(0)" className="icon">
              <img src={searchImg} alt="" />
            </a>
          </li>
          <li className={`ui-state-default ${tabTwoCls}`} onClick={this.changeTab.bind(null, 2)}>
            <a href="javascript:void(0)">Dashboard</a>
          </li>
        </ul>
        <div className="inside menu content inside-block ui-tabs-panel ui-widget-content ui-corner-bottom">

          { loadingOrFacets }

          {!_.isEqual(initialFilters, this.props.filters.toJS()) && hasDataForRefinedSearch && (
            <div
              onClick={this.clearAllFilter}
              className="ir-search-facet-link ir-search-facet-clear link-emulated active clear-all">
              Clear All Filters
            </div>
          )}
          <Loading type="spinner" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const caseLookupSearchReducer = state.get('caseLookupSearchReducer');
  return {
    facets: caseLookupSearchReducer.get('facets'),
    filters: caseLookupSearchReducer.get('filters'),
    sidebarData: state.get('sidebarData'),
    advancedSearchFacets: state.toJS().advancedSearch.data.facets,
    advancedSearchFilter: state.toJS().advancedSearch.filter,
    advancedSearchShowResults: state.toJS().advancedSearch.showResults,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  actions: bindActionCreators(actions, dispatch),
  errorActions: bindActionCreators(errorActions, dispatch),
  getSidebarData: bindActionCreators(getSidebarData, dispatch),
  onSearchAdvancedFilings: bindActionCreators(searchAdvancedFilings, dispatch),
});

FacetsBlock.propTypes = {
  getSidebarData: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  facets: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  sidebarData: PropTypes.object.isRequired,
  advancedSearchFacets: PropTypes.object,
  advancedSearchFilter: PropTypes.object.isRequired,
  onSearchAdvancedFilings: PropTypes.func.isRequired,
  advancedSearchShowResults: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FacetsBlock);



// WEBPACK FOOTER //
// ./src/pages/filings/FacetsBlock/FacetsBlock.js